import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible';
import Vant from 'vant'; //移动端UI框架
import VueAwesomeSwiper from 'vue-awesome-swiper' //swiper轮播插件
import 'swiper/dist/css/swiper.css'
import 'vant/lib/index.css';

import VueClipboard from 'vue-clipboard2';


Vue.use(Vant);
Vue.use(VueAwesomeSwiper);
Vue.use(VueClipboard);

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
